import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { DialogActionsBar, Dialog } from '@progress/kendo-react-dialogs';
import { useLocalization } from '@progress/kendo-react-intl';
import { messages, editorCancel, deleteConfirmation, editorDelete, deleteDialogTitle } from '../messages';
import { canUseDOM } from '@progress/kendo-react-common';
// tslint:disable:max-line-length
/**
 * Represents the default `removeDialog` component rendered by the [KendoReact SchedulerEditItem component]({% slug api_scheduler_scheduleredititem  %}).
 */
export var SchedulerRemoveDialog = function (props) {
    // tslint:enable:max-line-length
    var onClose = props.onClose, onCancel = props.onCancel, onConfirm = props.onConfirm;
    var localization = useLocalization();
    var removeCancelMessage = localization.toLanguageString(editorCancel, messages[editorCancel]);
    var removeConfirmMessage = localization.toLanguageString(editorDelete, messages[editorDelete]);
    var removeMessage = localization.toLanguageString(deleteConfirmation, messages[deleteConfirmation]);
    var deleteDialogTitleMessage = localization.toLanguageString(deleteDialogTitle, messages[deleteDialogTitle]);
    var handleClose = React.useCallback(function (_a) {
        var syntheticEvent = _a.syntheticEvent;
        if (!onClose) {
            return;
        }
        onClose.call(undefined, { syntheticEvent: syntheticEvent });
    }, [onClose]);
    var handleCancel = React.useCallback(function (syntheticEvent) {
        if (!onCancel) {
            return;
        }
        onCancel.call(undefined, { syntheticEvent: syntheticEvent, value: null });
    }, [onCancel]);
    var handleConfirm = React.useCallback(function (syntheticEvent) {
        if (!onConfirm) {
            return;
        }
        onConfirm.call(undefined, { syntheticEvent: syntheticEvent, value: null });
    }, [onConfirm]);
    return canUseDOM
        ? ReactDOM.createPortal((React.createElement(Dialog, { title: deleteDialogTitleMessage, onClose: handleClose },
            removeMessage,
            React.createElement(DialogActionsBar, null,
                React.createElement("button", { className: "k-button", onClick: handleCancel }, removeCancelMessage),
                React.createElement("button", { className: "k-button", onClick: handleConfirm }, removeConfirmMessage)))), document && document.body)
        : null;
};
//# sourceMappingURL=SchedulerRemoveDialog.js.map